import { type EnvironmentalConfig } from '@/utils/environmental-config';
import { createTimeoutPromise } from '@/utils/timeout-promise';

const fetchAllAuthMethods = async (
  email: string,
  datacenterKeys: string[],
  environmentalConfig: EnvironmentalConfig
): Promise<PromiseSettledResult<any>[]> => {
  const promises:Promise<any>[] = [];

  // We don't want to wait more than 5 seconds for this request
  const timeoutPromise = createTimeoutPromise();

  datacenterKeys.forEach((key => {
    const authMethodUrl = environmentalConfig.getAuthMethodUrl(key, email);

    if (authMethodUrl) {
      promises.push(Promise.race([fetch(authMethodUrl), timeoutPromise]));
    }
  }));

  return await Promise.allSettled(promises);
};

export { fetchAllAuthMethods };
